module.exports = "/_next/static/images/sa1-duotone-3ce63f334517d2d511ad53a1e6574092.svg";